import { Button, type ButtonProps } from "react-bootstrap";
import { MdArrowBackIos } from "react-icons/md";

const BackButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdArrowBackIos /> {children}
  </Button>
);

export default BackButton;
